$(function () {
    // ブランドグループのスライド
    $('#group-brand-swiper').swiper({
        slidesPerView: "auto",
        spaceBetween: 8,
    });

    // 使い方のスライド
    $('#howto-slider ').swiper({
        scrollbarHide: true,
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: 20,
        // autoHeight: true,
        grabCursor: true,
        preloadImages: true,
        paginationClickable: true,
        pagination: ".swiper-pagination",
        nextButton: ".swiper-button-next",
        prevButton: ".swiper-button-prev",
        loop: true
    });

    /*****ページ内スクロール*****/
    $('a[href^="#"]').on('click', function () {
        var speed = 600;
        var href = $(this).attr('href');
        var target = $(href === "#" || href === "" ? 'html' : href);
        var position = target.offset().top;
        $('html, body').animate({ scrollTop: position }, speed, 'swing');
        return false;
    });
});